import { HallowAnalyticsEvent } from "@packages/analytics";
import { Link } from "@packages/framework";
import { getURLFromDeeplink } from "@packages/sdk";

import type { CategoryMediumProps } from "../../categories/CategoryMedium/CategoryMedium.emotion";
import type { BaseGetSectionItemProps } from "./Section.emotion";

export type GetSectionItemCategoryPropsProps = BaseGetSectionItemProps & {
  size?: "m" | "l";
};

export const getSectionItemCategoryProps = ({
  analytics,
  section,
  item,
  link,
  size,
  pageId,
}: GetSectionItemCategoryPropsProps): CategoryMediumProps => ({
  asChild: link,
  children: link ? (
    <Link href={getURLFromDeeplink({ deeplink: item?.reference?.deeplink })} />
  ) : null,
  color: item?.reference?.color_hex as CategoryMediumProps["color"],
  description: item?.reference?.description,
  imgSrc: { large: item?.reference?.image_url },
  noDescription: size === "m",
  title: item?.reference?.title,
  onClickCapture: () =>
    analytics.track({
      event: HallowAnalyticsEvent.TappedContentCategory,
      properties: {
        section_item_id: item.id,
        section_id: section.id,
        page_id: pageId,
      },
    }),
});
